<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/goodslist' }">商品管理</el-breadcrumb-item>
            <el-breadcrumb-item>编辑商品</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区-->
        <el-card>
            <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="100px" style="width:90%;margin:10px auto">
                    <el-form-item label="所属类别" prop="goods_class">
                        <el-cascader v-model="editForm.goods_class" :options="classlist"></el-cascader>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="goods_name">
                        <el-input v-model="editForm.goods_name"></el-input>
                    </el-form-item>
                    <el-form-item label="商品图片" prop="goods_pic">
                        <el-upload
                            ref="imgBroadcastUpload"
                            :limit="limitNum"
                            :auto-upload="true"
                            :file-list="fileList"
                            :on-success="editPic"
                            :on-remove="delPic"
                            list-type="picture-card"
                            accept="image/jpg"
                            :action="uploadAction">
                                <i class="el-icon-plus"></i>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="商品简介" prop="goods_info">
                        <!--富文本编辑器-->
                        <!-- {{editForm.goods_info}} -->
                        <myeditor @editorContent="change($event)" :str="editForm.goods_info"></myeditor>
                    </el-form-item>
                    <el-form-item label="商品参数" prop="goods_param">
                        <!--富文本编辑器-->
                        <!-- {{editForm.goods_info}} -->
                        <myeditor @editorContent="change1($event)" :str="editForm.goods_param"></myeditor>
                    </el-form-item>
                    <el-form-item v-if="isWebSite" label="租售模式">
                        <el-tag type="success">仅出售（网站端固定）</el-tag>
                    </el-form-item>
                    <el-form-item v-else label="租售模式" prop="goods_sign">
                        <el-radio-group v-model="editForm.goods_sign" size="medium">
                            <el-radio label="1" border>仅出售</el-radio>
                            <el-radio label="2" border>仅租赁</el-radio>
                            <el-radio label="3" border>既出售又租赁</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="价格" prop="goods_price">
                        <el-input v-model="editForm.goods_price" style="width:300px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="月租金" prop="goods_month" v-if="editForm.goods_sign != '1'">
                        <el-input v-model="editForm.goods_month" style="width:300px" @blur="getDeposit"></el-input> 元
                    </el-form-item>
                    <el-form-item label="押金" prop="goods_deposit" v-if="editForm.goods_sign != '1'">
                        <el-input v-model="editForm.goods_deposit" style="width:300px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="商品佣金" prop="goods_commission">
                        <el-input v-model="editForm.goods_commission" style="width:300px"></el-input> 元
                    </el-form-item>
                    
                    <el-form-item label="是否显示">
                        <el-switch v-model="editForm.goods_index" active-value="True" inactive-value="False"></el-switch>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="EditGoodsSave">确 定</el-button>
                        <el-button >取 消</el-button>
                    </el-form-item>
                </el-form>
        </el-card>
    </div>
</template>
<script>
export default {
    computed: {
        isWebSite() {
            return window.sessionStorage.getItem('site') === 'web'
        },
        uploadAction() {
            const site = window.sessionStorage.getItem('site') || 'miniapp'
            return this.GLOBAL.imgURL + 'upload/?site=' + encodeURIComponent(site)
        }
    },
    data(){
        return {
            imgURL:this.GLOBAL.imgURL,
            limitNum: 3,
            fileList:[],
            classlist:[],
            brandlist:[],
            goods_id:'',
            //编辑表单数据
            editForm:{
                goods_class:'',
                 goods_name:'',
                 goods_pic:[],
                 goods_info:'',
                 goods_param:'',
                 goods_price:'',
                 goods_month:'',
                 goods_deposit:'',
                 goods_sign:'',
                 goods_commission:'',
                 goods_index:false,
            },
            goods_pic:[],
            //编辑表单验证规则
            editFormRules:{
                goods_class:[
                    { required: true, message: '请选择商品类型', trigger: 'blur' }
                ],
                goods_name:[
                    { required: true, message: '请输入商品名称', trigger: 'blur' }
                ],
                goods_info:[
                    { required: true, message: '请输入商品详情', trigger: 'blur' }
                ],
                goods_price:[
                    { required: true, message: '请输入商品价格', trigger: 'blur' }
                ],
                goods_month:[
                    { required: true, message: '请输入商品月租金', trigger: 'blur' }
                ],
                goods_deposit:[
                    { required: true, message: '请输入商品押金', trigger: 'blur' }
                ],
                goods_sign:[
                    { required: true, message: '请选择租售模式', trigger: 'blur' }
                ],
                goods_commission:[
                    { required: true, message: '请输入商品佣金', trigger: 'blur' }
                ]
            },
        }
    },
    mounted () {
        if (window.sessionStorage.getItem('site') === 'web') {
            this.editFormRules.goods_month = []
            this.editFormRules.goods_deposit = []
        }
        this.goods_id = this.$route.params.id
        this.getClass()
        this.editGoods()
    },
    methods:{
        async getClass(){
            const { data: res } = await this.$http.get('goodsclass/')
            this.classlist = res.data
        },
        async editGoods(){
            const { data: res } = await this.$http.get('goodsinfo/' + this.goods_id )
            this.editForm = res.data
            const gc = res.data.goods_class || ''
            this.editForm.goods_class = gc ? gc.split(',').map(s => s.trim()).filter(Boolean).map(Number) : []

            const rawPic = res.data.goods_pic || ''
            this.goods_pic = rawPic.split(',').map(s => s.trim()).filter(s => s !== '')
            this.fileList = this.goods_pic.map(item => ({
                name: item,
                url: this.resolveStaticPic(item)
            }))
            this.editForm.goods_pic = [...this.goods_pic]
            if (this.isWebSite) {
                this.editForm.goods_sign = '1'
                this.editForm.goods_month = ''
                this.editForm.goods_deposit = ''
            }
        },
        change(data) {
            this.editForm.goods_info = data;
        },
        change1(data) {
            this.editForm.goods_param = data;
        },
        getDeposit(){
            this.editForm.goods_deposit = this.editForm.goods_month * 3
        },
        editPic(response, file, fileList){
            const name = (response && response.picname) ? response.picname : (file && file.response && file.response.picname)
            if (name) {
                this.editForm.goods_pic.push(name)
            }
        },
        delPic(file,fileList){

            this.editForm.goods_pic = (fileList || []).map(item => {
                if (item.response && item.response.picname) return item.response.picname
                return item.name
            }).filter(Boolean)
            console.log(this.editForm.goods_pic);
            
        },
        async EditGoodsSave(){
            this.editForm.goods_class = this.editForm.goods_class.join(', ')
              this.$refs.editFormRef.validate( async valid=>{
                if (!valid) return
                const payload = { ...this.editForm }
                if (this.isWebSite) {
                    payload.goods_sign = '1'
                    payload.goods_month = ''
                    payload.goods_deposit = ''
                }
                const { data:res } = await this.$http.post('goodsedit/'+this.goods_id, payload)
                if(res.status===0)
                {
                    this.$message.success('修改商品成功！')
                    this.$router.push({path: '/goodslist'})
                }
              })
       },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
        
    }
    .el-breadcrumb{
        width: 100%;
    }
    
</style>